import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const ConfirmMessage = styled.div`
    text-align:center;
    color: #818181;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    letter-spacing: -0.14px;
    margin-top:30px;
`

export const ConfirmTitle = styled.div`
    text-align:center;
    color: #000;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 100% */
`

export const IconWrap = styled.div`
    width:50px;
    height:50px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:#F8F8F8;
    border-radius:6px;
    margin:auto auto 30px auto;
`